// Temporarily disable onboarding. Set to true to restore the widget and Tutorial menu item.
export const GET_STARTED_ENABLED = false;
